import React from "react";

export const selfReferralsConfig = [
  {
    auth: ["user"],
    routes: [
      {
        path: "/self-referral",
        component: React.lazy(() => import("./AppReferralsList")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/patient-approval",
        component: React.lazy(() => import("./AppDetails")),
      },
    ],
  },
 
];